import clsx from "clsx";
import { isNil } from "lodash";

import { type TableState } from "@features/sales-v4/types";
import { type SalesMetricV2 } from "@north-beam/nb-client-side/metrics-v2";
import { type SalesMetricRow } from "@north-beam/nb-common";
import { type CellContext } from "@tanstack/react-table";

import { getMetricComparison } from "../utils";

import { Tooltip } from "./tooltip";

type Props<TData> = {
  metric: SalesMetricV2;
  cell: CellContext<TData, unknown>;
  value?: string | number;
  tableState: TableState;
  rowItemName: string;
};

export const CellAovFormatter = <TData extends SalesMetricRow>({
  cell,
  metric,
  value,
  tableState,
  rowItemName,
}: Props<TData>) => {
  const row = cell.row.original as SalesMetricRow;
  const { metrics, comparisonMetrics } = row;

  return (
    <Tooltip
      metric={metric}
      row={cell.row.original}
      tableState={tableState}
      rowItemName={rowItemName}
    >
      <div
        className={clsx(
          "border-r-1 border-x-v2-tertiary px-4 py-2.5 bg-inherit text-v2-primary",
          "flex justify-end items-center h-full font-mono text-xs",
        )}
      >
        <div
          className={clsx("flex justify-end gap-1", {
            "flex-col items-end": tableState.showPercentChange,
            "items-center": !tableState.showPercentChange,
          })}
        >
          {!isNil(value) ? value : String(cell.getValue())}
          {getMetricComparison(
            metric,
            metrics,
            comparisonMetrics,
            tableState.showPercentChange,
          )}
        </div>
      </div>
    </Tooltip>
  );
};
